import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getCurrency, formatMoney} from '../../common/invoiceHelpers';
import {
  removeInvoiceFromSelected,
  updatePayAmountForInvoice,
  updateReason,
  updateReasonComment
} from "../../actions/InvoiceActions";
import * as appConstants from "../../constants/ApplicationConstants";
import {getSelectedPrimaryAccount, getPayerAccount} from "./Selectors";
import moment from 'moment';
import {trimLeadingZeroes} from "../../utils";
import {isCredit} from "./InvoiceList";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faTimes} from "@fortawesome/free-solid-svg-icons";

class InvoiceDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payValidation: '',
      reasonDescriptionValidation: '',
      readOnly: (!this.props.isPartialPaymentsAllowed && !this.props.isInvoiceOverpaymentAllowed) || isCredit(this.props.invoice),
      isCredit: isCredit(this.props.invoice),
      reasonNotRequired: this.props.reasonNotRequired !== 'X' ? 'Reason code required' : '',
      isItemPayment: this.props.invoice.item_is_a_payment === 'X',
      showReasonDescription: false,
      isModelStateValid: true,
    };
    this.onRemoveInvoiceFromSelected = this.onRemoveInvoiceFromSelected.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.onChangePayAmount = this.onChangePayAmount.bind(this);
    this.handleReasonCodeChange = this.handleReasonCodeChange.bind(this);
    this.isReasonCodeValid = this.isReasonCodeValid.bind(this);
    this.reasonCodeRequired = this.reasonCodeRequired.bind(this);
    this.getSoldToName = this.getSoldToName.bind(this);
  }

  isReasonCodeValid() {
    return this.props.reason && this.props.reason.length !== 0;
  }

  getSoldToName() {
    let custOption = '';
    if (this.props.accountType === appConstants.SOLD_TO_COMPARE) {
      const headerItems = this.props.userCustomerDetails;
      for (let l = 0; l < headerItems.length; l += 1) {
        const headerItem = headerItems[l];
        if (headerItem && headerItem.PrimaryAcct === this.props.selectedPrimaryAccount.PrimaryAcct) {
          custOption = `${headerItem.PrimaryAcct}${'-'}${headerItem.Name}`;
        }
      }
    } else {
      for (let l = 0; l < this.props.secondaryAccounts.length; l += 1) {
        const customer = this.props.secondaryAccounts[l];
        if (this.props.invoice.soldto_number === customer.value) {
          custOption = customer.label;
          break;
        }
      }
    }
    return custOption;
  }

  reasonCodeRequired() {
    return this.props.invoice.open_amount > this.props.payAmount;
  }

  onRemoveInvoiceFromSelected = (e) => {
    this.props.dispatch(removeInvoiceFromSelected(this.props.invoice));
  };

  onChangePayAmount = (e) => {
    const {value} = e.target;
    this.props.dispatch(updatePayAmountForInvoice(
      this.props.documentId,
      value ? parseFloat(value) : null,
      this.props.invoice.open_amount,
      this.props.isPartialPaymentsAllowed,
      this.props.isInvoiceOverpaymentAllowed
    ));
  };

  handleReasonChange = (e) => {
    this.props.dispatch(updateReasonComment(this.props.documentId, e.target.value));
  };

  mapSoldToolTip(soldTo) {
    this.props.onMapSoldTo(soldTo);
  }

  handleReasonCodeChange = (selectedReasonCodeOption) => {
    this.props.dispatch(updateReason(this.props.documentId, selectedReasonCodeOption.target.value));
  };

  errorClass = valid => (valid ? '' : 'invalid');

  render() {
    const payerCompanyCode = this.props.payerAccount && this.props.payerAccount.CompanyCode ? this.props.payerAccount.CompanyCode : '';

    const reasonCodes = this.props.cnbsConfig.payment_reason_codes
      .filter(obj => obj.company_code === payerCompanyCode && obj.payment_type === 'O')
      .map(code => {
        return {
          value: code.reason_code,
          label: code.description,
          commentsRequired: code.comments_required,
          clearableValue: false,
        }
      });

    let selectedReasonCode = this.props.cnbsConfig.payment_reason_codes.find((reason) => {
      return reason.reason_code === this.props.reason;
    });
    const postingDate = this.props.invoice && this.props.invoice.posting_date ? moment(this.props.invoice.posting_date).format('MM/DD/YYYY') : '';
    const dueDate = this.props.invoice && this.props.invoice.due_date ? moment(this.props.invoice.due_date).format('MM/DD/YYYY') : '';
    const payAmount = this.props.payAmount;
    return (
      <div>
        <div>
          <div
            role="presentation"
            onClick={this.onRemoveInvoiceFromSelected}
            className="remove-invoice-button"
          >
            <FontAwesomeIcon icon={faTimes} className={"text-secondary"}/>
          </div>
        </div>
        <div className="row">
          <div className="row col-12 col-md-6 col-lg-3 mt-2">
            <div className="details-label-column">Doc #</div>
            <div className="details-value">{trimLeadingZeroes(this.props.invoice.billing_document_number)}</div>
          </div>
          <div className="row col-12 col-md-6 col-lg-3 mt-2">
            <div
              className="details-label-column">{this.props.invoice.open_amount < 0 ? 'Credit' : 'Open'}</div>
            <div className={`details-value ${this.props.invoice.open_amount < 0 ? 'itemPayment' : ''}`}>
              {getCurrency(this.props.invoice)} {formatMoney(this.props.invoice.open_amount)}
            </div>
          </div>
          <div className="row col-12 col-md-6 col-lg-2 mt-2">
            <div className="details-label-column">Date</div>
            <div className="details-value">
              {postingDate}
            </div>
          </div>
          <div className="row col-12 col-md-6 col-lg-2 mt-2">
            <div className="details-label-column">Due</div>
            <div className="details-value">
              {dueDate}
            </div>
          </div>
          <div className="row col-12 col-md-6 col-lg-2 mt-2">
            <div className="details-label-column">Cust#</div>
            <div data-toggle="details-value tooltip"
                 title={this.getSoldToName()}>{trimLeadingZeroes(this.props.invoice.soldto_number)}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 mt-2">
            <div className="row">
              <div className="details-label-column">
                Ref #
              </div>
              <div
                className="details-value">
                {trimLeadingZeroes(this.props.invoice.reference_number)}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mt-2">
            <div className="row">
              {this.props.invoice.open_amount >= 0 && <React.Fragment>
                <div
                  className="details-label-column">
                  Pay
                </div>
                <div
                  className="details-value">
                  <input
                    required
                    id={`${'payAmount_'}${this.props.invoice.document_number_finance}`}
                    name={`${'payAmount_'}${this.props.invoice.document_number_finance}`}
                    className={`form-control form-control-sm text-left ${this.state.isCredit ? 'itemPayment' : ''} ${this.errorClass(this.props.amountValidation.length === 0)}`}
                    type="number"
                    step={0.01}
                    onChange={this.onChangePayAmount}
                    value={payAmount}
                    readOnly={this.state.readOnly}
                  />
                  {this.props.amountValidation ? <h6 className="invalid-Text">
                    <small>{this.props.amountValidation}</small>
                  </h6> : ''}
                </div>
              </React.Fragment>}
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mt-2">
            <div className="row">
              {
                this.reasonCodeRequired() ?
                  <div
                    className="details-label-column">
                    Reason
                  </div>
                  : ''
              }
              {
                this.reasonCodeRequired() ?
                  <div className="details-value invoiceDetailCustomSelect">
                    <select
                      name="paymentStatus"
                      className={`form-control ${this.errorClass(this.isReasonCodeValid())}`}
                      onChange={this.handleReasonCodeChange}>
                      value={this.props.reason}
                      <option value="" disabled selected="selected">Reason Code</option>
                      {reasonCodes.map(code => {
                        return (
                          <option value={code.value} key={code.value}>
                            {code.label}
                          </option>
                        )
                      })}
                    </select>
                    <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
                    {this.isReasonCodeValid() ? '' : <h6 className="invalid-Text">
                      <small>Reason Code Required.</small>
                    </h6>}
                  </div>
                  : ''
              }
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mt-2">
            <div className="row">
              <div className="details-label-column d-lg-none"/>
              <div className="details-value">
                {
                  this.reasonCodeRequired() && selectedReasonCode && selectedReasonCode.comments_required && selectedReasonCode.comments_required === "X" ?
                    <input
                      required
                      id={`${'reasonDescription_'}${this.props.invoice.document_number_finance}`}
                      name={`${'reasonDescription_'}${this.props.invoice.document_number_finance}`}
                      className={`form-control form-control-sm text-left ${this.props.comment.length === 0 && 'invalid'}`}
                      placeholder="Reason Description"
                      onChange={this.handleReasonChange}
                      value={this.props.comment}
                    />
                    : ''
                }
                {
                  this.reasonCodeRequired() && selectedReasonCode && selectedReasonCode.comments_required && selectedReasonCode.comments_required === "X" && this.props.comment.length === 0 &&
                  <h6 className="invalid-Text">
                    <small>Reason Required</small>
                  </h6>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

InvoiceDetail.propTypes = {
  documentId: PropTypes.string.isRequired,
};

export default connect((store, props) => ({
  cnbsConfig: store.app.cnbsConfig,
  isPartialPaymentsAllowed: store.app.isPartialPaymentsAllowed,
  isInvoiceOverpaymentAllowed: store.app.isInvoiceOverpaymentAllowed,
  payAmount: store.invoice.invoiceDetail[props.documentId].amount,
  amountValidation: store.invoice.invoiceDetail[props.documentId].amountValidation,
  reason: store.invoice.invoiceDetail[props.documentId].reason,
  comment: store.invoice.invoiceDetail[props.documentId].comment,
  invoice: store.invoice.selected[props.documentId],
  userCustomerDetails: store.user_options.primaryAccounts,
  selectedPrimaryAccount: getSelectedPrimaryAccount(store, props),
  secondaryAccounts: store.user_options.secondaryAccounts,
  accountType: store.user_options.accountType,
  payerAccount: getPayerAccount(store, props),
}))(InvoiceDetail);
